/* AUTO-SYNCED from PsyKit.io/lib/session-topics.ts — DO NOT EDIT. Regenerate with `npm run sync`. */
/**
 * lib/session-topics.ts — shared topic taxonomy for sessions.
 *
 * Topics tie related sessions together for longitudinal progress tracking.
 * Distinct from scripts.category (script-library organization) — see Slice A.6.
 *
 * The seed list below is curated for ART(R) and trauma-adjacent therapy
 * practice. Therapists can also enter free-text values via the "+ Add custom
 * topic" affordance — the database column is TEXT, not an enum, so additions
 * are first-class without a migration.
 *
 * Free-text values land alongside the seed in any subsequent topic dropdown
 * (computed at runtime from prior session_records.topic_category values).
 */

export const TOPIC_CATEGORIES_SEED = [
  "PTSD",
  "Anxiety",
  "Panic",
  "Grief",
  "Phobia",
  "OCD",
  "Depression",
  "Trauma",
  "Other",
] as const;

/**
 * Compile-time helper: one of the seed values. At runtime the column accepts
 * any string (so therapist-added topics are valid). Use this type only in
 * contexts where you're enumerating the seed list, not when validating user
 * input.
 */
export type SeedTopicCategory = (typeof TOPIC_CATEGORIES_SEED)[number];

/**
 * What the API actually accepts: any string (or null when no topic chosen).
 * Length-capped at 60 chars to match the input maxLength, matching the
 * pattern used elsewhere (e.g. scripts.category, client_profiles.display_name).
 */
export type TopicCategory = string;

export const TOPIC_LABEL_MAX = 80;
export const TOPIC_CATEGORY_MAX = 60;
